import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as PropertiesRequiredSVG } from '@Assets/Svgs/ic_properties_required.svg';
import TX from '../Text';

const NonCompletionNotice = ({ text }) => (
  <NonCompletionNoticeContainer>
    <NonCompletionNoticeIcon />
    <NonCompletionNoticeText>{text}</NonCompletionNoticeText>
  </NonCompletionNoticeContainer>
);

NonCompletionNotice.propTypes = {
  text: PropTypes.string.isRequired,
};

const NonCompletionNoticeContainer = styled.div`
  display: flex;
  align-items: center;

  padding: 2px 5px 2px 2px;
  border-radius: 5px;
  user-select: none;

  background-color: rgb(255, 85, 85, 0.1);
`;

const NonCompletionNoticeIcon = styled(PropertiesRequiredSVG)`
  width: 16px;
  height: 16px;

  fill: ${({ theme }) => theme.colors.danger};
`;

const NonCompletionNoticeText = styled(TX.Caption1)`
  color: ${({ theme }) => theme.colors.danger};
`;

export default NonCompletionNotice;
